import { Box, type BoxProps, Img } from '@chakra-ui/react'

import DiagonalAvatars from './DiagonalAvatars'

type AvatarWithIconSize = 'sm' | 'md'

const SIZE_TO_UI_DETAILS: Record<
  AvatarWithIconSize,
  {
    boxSize: BoxProps['width']
    avatarSize: BoxProps['width']
    borderRadius: BoxProps['borderRadius']
  }
> = {
  sm: {
    boxSize: '32px',
    avatarSize: '21px',
    borderRadius: '2px',
  },
  md: {
    boxSize: '48px',
    avatarSize: '32px',
    borderRadius: '4px',
  },
}

export default function DiagonalAvatarsWithIcon({
  userA,
  userB,
  iconEntity,
  size,
}: {
  userA: React.ComponentProps<typeof DiagonalAvatars>['userA']
  userB: React.ComponentProps<typeof DiagonalAvatars>['userB']
  iconEntity: { iconUrl: string; primaryColor?: string }
  size: 'sm' | 'md'
}): JSX.Element {
  const { primaryColor, iconUrl } = iconEntity
  const { boxSize, avatarSize, borderRadius } = SIZE_TO_UI_DETAILS[size]

  return (
    <Box width={boxSize} height={boxSize} position="relative">
      <Img
        bg={primaryColor}
        src={iconUrl}
        cursor="default"
        width={avatarSize}
        height={avatarSize}
        position="absolute"
        top="0"
        left="0"
        borderRadius={borderRadius}
      />
      <DiagonalAvatars
        userA={userA}
        userB={userB}
        position="absolute"
        bottom="0"
        right="0"
        size="sm"
        width={avatarSize}
        height={avatarSize}
        orientation="up"
      />
    </Box>
  )
}
